import { mergeSx } from '@cast/design-system';
import {
  PageHeader as BasePageHeader,
  PageHeaderProps as BasePageHeaderProps,
} from '@cast/shared-layout-ui';

import { InitiateTour, InitiateTourProps } from 'core/tour';

export type PageHeaderProps = Omit<BasePageHeaderProps, 'tourSlot'> & {
  initiateTour?: InitiateTourProps;
};

/**
 * @deprecated use `PageHeader` from `@cast/design-system`
 */
export const PageHeader = ({ initiateTour, ...props }: PageHeaderProps) => {
  return (
    <BasePageHeader
      {...props}
      tourSlot={
        initiateTour ? (
          <InitiateTour
            {...initiateTour}
            sx={mergeSx(
              { position: 'absolute', display: 'inline-block' },
              initiateTour.sx
            )}
          />
        ) : undefined
      }
    />
  );
};
